<h2 mat-dialog-title>Move Cable Select Project</h2>

<div mat-dialog-content>

    <div class="p-4">

        <form (formValueChange)="formValueChange.set($event)"
              (formValid)="formValid.set($event)"
              (formDirty)="formDirty.set($event)">

            <div class="mce-form-section">

                @if(vm.noToProjects){
                <div>
                    <p>
                        You do not have any project to which you can move cables.
                    </p>
                    <p>
                        You will only be able to move cables once you have more than two projects.
                    </p>
                </div>
                }

                @if(vm.someToProjects){

                <div>Select project to move cable(s) to:</div>
                <div class="mce-form-field-group">
                    <mat-form-field class="w-full">
                        <mat-label>{{vm.showLoading ? 'loading...' : 'Select Project'}}</mat-label>
                        <mat-select [(ngModel)]="formValue.toProjectUid"
                                    name="toProject"
                                    [disabled]="vm.showLoading">
                            @for (toProject of vm.toProjects; track toProject.value) {
                            <mat-option [value]="toProject.value">{{toProject.label}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                }
            </div>

        </form>

    </div>

    @if (vm.showLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }


</div>

<mat-dialog-actions>

    <div class="w-full">
        <mce-save-cancel [config]="saveCancelConfig()"
                         (action)="onSaveCancelAction($event)">
        </mce-save-cancel>
    </div>

</mat-dialog-actions>



